import React, { useContext, useState, useEffect, useCallback } from 'react';
import AuthContext from '../../authcontext/AuthContext';
import { NumericFormat } from "react-number-format";
import bedIcon from "../../../assets/bedIcon.png"
import bathIcon from "../../../assets/bathIcon.png"
import axios from 'axios';
import { config } from '../../../utils/config';
import Counter from '../../common/Counter';
import { convertToUtcTimeSS } from '../../../utils/timeConversion';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';


export default function UserDashboard() {

    const authData = useContext(AuthContext);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("property");
    const [dashBoardItems, setdashBoardItems] = useState([])

    useEffect(() => {

        const getUserItems = async () => {

            const bidToken = authData.getClientToken()
            console.log("bidding page bid token", bidToken)
            const response = await axios.get(`${config.apiBaseUrl}/user/dashboard/record`, {
                params: {
                    bidToken
                }
            })

            console.log(response.data)
            setdashBoardItems(() => response.data)
        }

        getUserItems()

    }, [])

    const toBidPage = useCallback((biddingId) => {

        navigate(`/bidding/${biddingId}`)

    }, [navigate])


    return (
        <>
            <div className="container-fluid p-1" style={{ width: "90%" }}>
                <h1>User Dashboard</h1>
                <h4>Hi, Welcome back ({authData.getUserDetail().username})!</h4>
                <ul className="nav nav-pills mb-3">
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === "property" ? "active" : ""} `} onClick={() => setActiveTab("property")}>Property</button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === "profile" ? "active" : ""} `} onClick={() => setActiveTab("profile")}>Profile</button>
                    </li>
                </ul>
                <div>
                    {activeTab === "property" ? <div className="tab-pane">

                        <div className="row row-cols-1 g-4">
                            {dashBoardItems.map((obj) => {
                                return (
                                    <div className="col" key={obj.id}>
                                        <div className="card mb-3" style={{ maxWidth: "1000px" }}>
                                            <div className="row g-0">
                                                <div className="col-md-4" style={{
                                                    overflow: 'hidden',
                                                    height: '200px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>
                                                    <img src={obj.bidDetails.listingDetails.media[0].media_url} style={{ objectFit: 'cover', width: '100%', height: '100%' }} className="img-fluid rounded-start" alt="..." />
                                                    <div className="card-img-overlay">
                                                        <h6><span className="badge bg-danger"><Counter dateTime={convertToUtcTimeSS(obj.bidDetails.end_time)} />Left</span></h6>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="card-body">
                                                        <h5><span className="badge bg-secondary">${obj.amount / 100} SGD Deposit Paid</span></h5>
                                                        <h5 className="card-title">{obj.bidDetails.listingDetails.propertyDetails.project_name && obj.bidDetails.listingDetails.propertyDetails.project_name
                                                            !== "Nil" ? obj.bidDetails.listingDetails.propertyDetails.project_name : obj.bidDetails.listingDetails.propertyDetails.street_name}</h5>
                                                        <p className="card-text" style={{ margin: "0", lineHeight: "1.5" }}>{obj.bidDetails.listingDetails.unit ? "#" + obj.bidDetails.listingDetails.unit : null}</p>
                                                        <p className="card-text" style={{ margin: "0", lineHeight: "1.5" }}>{obj.bidDetails.listingDetails.propertyDetails.block} {obj.bidDetails.listingDetails.propertyDetails.street_name} {obj.bidDetails.listingDetails.propertyDetails.postal_code}</p>
                                                        <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                            <NumericFormat className="card-text" prefix={"$"} suffix={""} thousandSeparator={true} value="Need to update" displayType={"text"} />
                                                            {" . "}<NumericFormat className="card-text" prefix={"$"} suffix={"psf (floor)"} thousandSeparator={true} value="Need to update. probably with opening bid or latest bid?" displayType={"text"} />
                                                            {obj.bidDetails.listingDetails.size_land ? <NumericFormat className="card-text" prefix={" . $"} suffix={"psf (land)"} thousandSeparator={true} value="Need to update" displayType={"text"} /> : null}
                                                        </p>
                                                        <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                            {obj.bidDetails.listingDetails.room}{" "}<img src={bedIcon} style={{ width: "20px" }} />
                                                            {" " + obj.bidDetails.listingDetails.bath + " "}<img src={bathIcon} style={{ width: "20px" }} />
                                                            {" . "}<NumericFormat className="card-text" prefix={""} suffix={"sqft (floor)"} thousandSeparator={true} value={obj.bidDetails.listingDetails.size_built} displayType={"text"} />
                                                            {obj.bidDetails.listingDetails.size_land ? <NumericFormat className="card-text" prefix={" . "} suffix={"sqft (land)"} thousandSeparator={true} value={obj.bidDetails.listingDetails.size_land} displayType={"text"} /> : null}
                                                        </p>
                                                        <div className='my-2'>
                                                            <Button variant="danger" className='mx-2' onClick={() => { toBidPage(obj.bid_detail_id) }}>Bid Property</Button>
                                                            <button className='btn btn-danger btn-sm mx-2' onClick={() => { toBidPage(2) }}>Bid Property</button>
                                                            <Button variant="danger">Submit</Button>
                                                         
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                    </div> : null}

                    {activeTab === "profile" ? <div className="tab-pane">Your profile is here

                        {/* <span onKeyUp={checkNric}>
                        <TextBlock label="NRIC" updateParentValue={(value) => (setNric(value))} value={nric} errorMessage={nricError} />
                    </span>
                    <span onKeyUp={checkName}>
                        <TextBlock label="Full Name (As Per NRIC)" updateParentValue={(value) => (setName(value))} value={name} errorMessage={nameError} />
                    </span>
                    <span onChange={checkAddress}>
                        <GetAddress label="NRIC Address" updateParentValue={(value) => (setAddress(value))} value={address} errorMessage={addressError} />
                    </span>
                    <span>
                        <TextBlock label="Floor" updateParentValue={(value) => (setFloor(value))} value={floor} />
                    </span>
                    <span>
                        <TextBlock label="Unit" updateParentValue={(value) => (setUnit(value))} value={unit} />
                    </span>
                    <span onChange={checkResident}>
                        <DropdownBlock label="Resident Status" updateParentValue={(value) => (setResidentStatus(value))}
                            option={options.map((d) => { return (d.residentStatus) })} value={residentStatus} errorMessage={residentError} />
                    </span>
                    <span onKeyUp={checkCountry}>
                        <TextBlock label="Country of Residence" updateParentValue={(value) => (setCountry(value))} value={country} errorMessage={countryError} />
                    </span>
                    <span onKeyUp={checkMobile}>
                        <TextBlock type="number" label="Mobile Number" updateParentValue={(value) => (setMobile(value))} value={mobile} errorMessage={mobileError} />
                    </span> */}



                    </div> : null}
                </div>


            </div>
        </>
    )
}